import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconCalendarRemoveComponent } from "./med-icon-calendar-remove.component";

@NgModule({
  declarations: [
    MedIconCalendarRemoveComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconCalendarRemoveComponent,
  ],
})
export class MedIconCalendarRemoveModule { }
